module.exports = __webpack_public_path__ + "media/images/pikkachan_hatena-5b85007975d57f62b15e96dd3547afcb.svg";